var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconListenColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 58,
    viewBox: "0 0 50 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5843 30.7234C46.9549 22.7503 41.7094 8.37769 25.973 8.37769H24.2944C8.55797 8.37769 3.31249 22.8552 2.68303 30.7234L2.57812 46.4599C2.57812 47.7188 3.62722 48.7679 4.88614 48.7679H11.7053C15.482 48.7679 18.5244 45.7255 18.5244 41.9487V37.4376C18.5244 33.6609 15.482 30.6185 11.7053 30.6185H7.08924H6.98433C7.19415 29.1498 7.71869 25.4779 9.60707 21.7012C12.6494 15.6164 17.5802 12.4692 24.2944 12.4692H25.973C40.4505 12.4692 42.9683 27.4712 43.283 30.7234H43.1781H38.667C34.8903 30.7234 31.8479 33.7658 31.8479 37.5425V42.0537C31.8479 45.8304 34.8903 48.8728 38.667 48.8728H45.4861C46.7451 48.8728 47.6892 47.8237 47.6892 46.5648L47.5843 30.7234Z",
    fill: "#B5C8A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListenColor);
export default __webpack_public_path__ + "static/media/icon_listen_color.7eca841f651dee5332d6585cfc41ed95.svg";
export { ForwardRef as ReactComponent };